<template>
    <main class="main" id="main">
        <navigate></navigate>
        <section class="section s-lk">

            <div class="container">
                <div class="personal-info_box new-lk">
                    <form action="" class="profile_info">
                        <div class="info_row">
                            <span>Фамилия</span>
                            <input type="text" placeholder="Введите текст" v-model="user.surname">
                        </div>

                        <div class="info_row">
                            <span>Имя</span>
                            <input type="text" placeholder="Введите текст" v-model="user.name">
                        </div>

                        <div class="info_row">
                            <span>Отчество</span>
                            <input type="text" placeholder="Введите текст" v-model="user.patronymic">
                        </div>

                        <div class="info_row">
                            <span>E-mail</span>
                            <input type="text" placeholder="Введите текст"  v-model="user.email">
                        </div>

                        <div class="info_row">
                            <span>Тел. номер</span>
                            <input type="text" placeholder="+7(__)___ __ __" v-model="user.phone" data-inputmask="'mask': '+9(999)999-99-99'">
                        </div>

                        <div class="info_row">
                            <span>E-mail (для уведомлений)</span>
                            <input type="text" placeholder="Введите текст"  v-model="user.info_email">
                        </div>

                        <div class="info_row">
                            <span>Контракт / Договор</span>
                            <input type="text" placeholder="Введите текст" v-model="user.contract">
                        </div>

                        <div class="info_row">
                            <span>Пол</span>
                            <select class="select_info select_sexs" name="amount" v-model="sexs">
                                <option value="1">Мужской</option>
                                <option value="0">Женский</option>
                            </select>
                        </div>

                        <div class="info_row">
                            <span>Дата рождения</span>
                            <input type="date" placeholder="__ __ _____" v-model="user.birthday">
                        </div>

                        <div class="info_row">
                            <span>Город</span>
                            <select class="select select_city select_info" name="city" v-model="citys">
                                <option v-if="user.city" :value="(user.city).toString()">{{user.city_name}}</option>
                            </select>
                        </div>

                        <div class="info_row">
                            <span>Улица</span>
                            <input type="text" placeholder="Введите текст" v-model="user.address">
                        </div>

                        <button class="menu_item_btn" @click="saveProfile">СОХРАНИТЬ</button>
                    </form>
                </div>
            </div>
        </section>

    </main>

</template>

<script>
import Inputmask from 'inputmask'
import navigate from '@/pages/lk/user/navigate'
import axios from '@/router/http'
import 'select2/dist/css/select2.min.css'
import 'select2'
export default {
  name: 'personal',
  components: {navigate},
  props: ['city', 'auth', 'basket', 'geo', 'user'],
  data () {
    return {
      pay: 'bonus',
      sexs: '',
      citys: ''
    }
  },
  created () {
    if (this.auth.uid) this.initAjax()
    else {
      let interval = setInterval(() => {
        if (this.auth.uid) {
          clearInterval(interval)
          this.initAjax()
        }
      }, 100)
    }
  },
  watch: {
    'sexs' (val) {
      $('.select_sexs').val(val).trigger('change.select2')
    },
    'citys' (val) {
      $('.select_city').val(val).trigger('change.select2')
    },
    user: {
      handler (newVal, oldVal) {
        this.sexs = this.user.sexs
        this.citys = this.user.city.toString()
      },
      deep: true
    }
  },
  methods: {
    initAjax () {
      Inputmask().remove(document.getElementById('input'))
      setTimeout(() => { Inputmask().mask(document.querySelectorAll('input')) }, 500)
      let self = this
      $('.select_sexs').select2({
        width: '100%'
      }).val(this.sexs).trigger('change.select2').on('select2:select', function () {
        self.sexs = $(this).val()
      })
      $('.select_city').select2({
        width: '100%',
        ajax: {
          url: 'https://lk.when-hungry.com/site/search-city',
          data: (params) => {
            params.id = this.city.country_id
            params.q = params.term
            params.all = 0
            params.country = 1
            params.comm = 1
            return params
          },
          dataType: 'json',
          processResults: function (data) {
            return {
              results: $.map(data, function (key, item) {
                return {
                  text: key,
                  id: item
                }
              })
            }
          }
        }
      }).val(this.user.city_id).trigger('change.select2').on('select2:select', function () {
        self.citys = $(this).val()
      })
      this.sexs = this.user.sexs
      this.citys = this.user.city.toString()
    },
    saveProfile () {
      var formData = new FormData()
      formData.append('name', this.user.name)
      formData.append('surname', this.user.surname)
      formData.append('patronymic', this.user.patronymic)
      formData.append('sex', this.sexs)
      formData.append('city_id', this.citys)
      formData.append('birthday', this.user.birthday)
      formData.append('email', this.user.email)
      formData.append('info_email', this.user.info_email)
      formData.append('contract', this.user.contract)
      formData.append('phone', this.user.phone)
      formData.append('address', this.user.address)
      formData.append('uid', this.auth.uid)
      axios.post('https://lk.when-hungry.com/mobile/put-mobile',
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }
      )
      setTimeout(() => { alert('Изменения успешно сохранены') }, 100)
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/lk/user/personal.vue